import React, { useMemo } from 'react';
import styled from 'styled-components';
import { APP_ENV } from 'appenv';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { Link } from 'react-router-dom';
import Routes from 'Routes';
import HelpButton from 'components/appbar/HelpButton';
import EventLogo from 'assets/event-logo.png';
import PolyULogo from 'assets/polyu-logo.png';
import SPEEDLogo from 'assets/speed-logo.png';

const RootContainer = styled.div`
  width: 100%;
`;

const useAppBarStyles = makeStyles(() => ({
  root: {
    zIndex: 1000,
  },
  colorPrimary: {
    color: '#484848',
    backgroundColor: '#FFF',
  },
}));

const StyledToolbar = withStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
}))(Toolbar);

const StyledLogoContainer = styled.div`
  flex: 1 0 auto;

  @media only screen and (max-width: 960px) {
    display: flex;
    top: 0;
    left: 30%;
    right: 30%;
    height: 100%;
    align-items: center;
    justify-content: center;
  }
`;

const LogoContainer = styled.img`
  display: inline;
  align-self: center;
  height: ${({ logoHeight }) => logoHeight}px;
  vertical-align: middle;

  &:not(:last-child) {
    margin-right: 24px;
  }

  @media only screen and (max-width: 960px) {
    height: ${({ logoHeightMobile }) => logoHeightMobile}px;
    &:not(:last-child) {
      margin-right: 8px;
    }
  }
`;

const StyledLink = styled(Link)`
  display: inline-block;
`;

export default function TopBar() {
  const appBarClasses = useAppBarStyles();

  const logoUrlList = useMemo(() => {
    switch (APP_ENV) {
      case 'polyu618_staging': case 'polyu618_production':
        return [PolyULogo, SPEEDLogo];
      default: return [EventLogo];
    }
  }, []);

  const logoHeight = useMemo(() => {
    switch (APP_ENV) {
      case 'polyu618_staging':
      case 'polyu618_production':
        return 40;
      default: return 56;
    }
  }, []);

  const logoHeightMobile = useMemo(() => {
    switch (APP_ENV) {
      case 'polyu618_staging':
      case 'polyu618_production':
        return 30;
      default:
        return 56;
    }
  }, []);

  return (
    <RootContainer>
      <AppBar
        position="static"
        className={`${appBarClasses.root} ${appBarClasses.colorPrimary}`}
        elevation={0}
      >
        <StyledToolbar>
          <StyledLogoContainer>
            <StyledLink to={Routes.landing}>
              {logoUrlList.map((logoUrl) => (
                <LogoContainer
                  logoHeight={logoHeight}
                  logoHeightMobile={logoHeightMobile}
                  src={logoUrl}
                  alt="Event Logo"
                />
              ))}
            </StyledLink>
          </StyledLogoContainer>
          <HelpButton />
        </StyledToolbar>
      </AppBar>
    </RootContainer>
  );
}
